import { gql } from "apollo-boost";
import { fragments } from "../queries/User";

export default gql`
  mutation UpdateUser($id: ID!, $input: UserInput!) {
    updateUser(id: $id, input: $input) {
      ...UserQueryUser
    }
  }
  ${fragments.user}
`;



// WEBPACK FOOTER //
// ./src/mutations/UpdateUser.js